import { Component, Input } from '@angular/core';

@Component({
  selector: 'wg-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {
  @Input() mainFeed!: boolean;
}
